import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#7C3AED',
        secondary: '#6D28D9',
        accent: '#8B5CF6',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
})
